import { createAction, props } from '@ngrx/store';
import {TRAININGS_SET_CATEGORIES} from "./action-types";
import {PostCategory} from "../../types";

export const setCategories = createAction(TRAININGS_SET_CATEGORIES, props<{ categories: PostCategory[] }>());
